import { cn } from '@/lib/utils'

interface CircleLocationProps {
  className?: string
}

const LocationIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M22.331 6.941C21.743 5.584 20.894 4.356 19.834 3.325C18.77 2.285 17.516 1.46 16.14 0.894C14.709 0.3 13.19 0 11.625 0C10.059 0 8.54 0.3 7.109 0.891C5.725 1.463 4.484 2.281 3.415 3.322C2.356 4.353 1.507 5.581 0.918 6.938C0.309 8.344 0 9.838 0 11.375C0 13.581 0.528 15.778 1.566 17.897C2.4 19.6 3.566 21.26 5.034 22.838C7.544 25.531 10.175 27.178 10.922 27.619C11.134 27.744 11.375 27.81 11.622 27.81C11.865 27.81 12.106 27.747 12.322 27.619C13.068 27.178 15.7 25.531 18.209 22.838C19.678 21.263 20.844 19.6 21.678 17.897C22.722 15.781 23.25 13.588 23.25 11.378C23.25 9.841 22.941 8.347 22.331 6.941ZM11.625 25.413C9.565 24.103 2.25 18.919 2.25 11.378C2.25 8.944 3.222 6.656 4.987 4.931C6.759 3.203 9.116 2.25 11.625 2.25C14.134 2.25 16.491 3.203 18.262 4.934C20.028 6.656 21 8.944 21 11.378C21 18.919 13.684 24.103 11.625 25.413ZM11.625 6.125C8.587 6.125 6.125 8.588 6.125 11.625C6.125 14.663 8.587 17.125 11.625 17.125C14.662 17.125 17.125 14.663 17.125 11.625C17.125 8.588 14.662 6.125 11.625 6.125ZM14.1 14.1C13.775 14.426 13.39 14.684 12.965 14.86C12.54 15.036 12.084 15.126 11.625 15.125C10.69 15.125 9.812 14.76 9.15 14.1C8.824 13.776 8.566 13.39 8.39 12.965C8.214 12.54 8.124 12.085 8.125 11.625C8.125 10.691 8.49 9.813 9.15 9.15C9.812 8.488 10.69 8.125 11.625 8.125C12.559 8.125 13.437 8.488 14.1 9.15C14.762 9.813 15.125 10.691 15.125 11.625C15.125 12.56 14.762 13.438 14.1 14.1Z"
      fill="currentColor"
    />
  </svg>
)

const CircleLocation = ({ className }: CircleLocationProps) => {
  return (
    <div
      className={cn(
        'flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-lg shadow-slate-200',
        className,
      )}
    >
      <LocationIcon className="text-red h-7 w-7" />
    </div>
  )
}

export default CircleLocation
